import { asMultiStyleConfig } from '../../../../utils/theme';
export var Alert = asMultiStyleConfig({
  parts: ['container', 'title', 'description', 'icon', 'actionContainer'],
  baseStyle: {
    container: {
      borderRadius: 'unset'
    },
    actionContainer: {
      ml: {
        base: 9,
        md: 16
      }
    }
  },
  colorSchemes: {
    blue: {
      container: {
        backgroundColor: 'grey.270',
        borderColor: 'blue.600'
      },
      icon: {
        color: 'blue.600'
      }
    },
    red: {
      container: {
        backgroundColor: 'red.100',
        borderColor: 'red.400'
      },
      icon: {
        color: 'red.400'
      }
    },
    green: {
      container: {
        backgroundColor: 'green.200',
        borderColor: 'green.600'
      },
      icon: {
        color: 'green.600'
      }
    },
    yellow: {
      container: {
        backgroundColor: 'yellow.100',
        borderColor: 'orange.600'
      },
      icon: {
        color: 'orange.600'
      }
    }
  },
  sizes: {
    sm: {
      container: {
        borderWidth: '3px',
        borderRadius: 'unset',
        py: 2,
        px: 3
      }
    },
    md: {
      container: {
        borderRadius: 'unset',
        borderLeft: '8px',
        py: 6,
        px: 8
      }
    }
  },
  variants: {
    inline: {
      container: {
        borderLeftWidth: '4px',
        borderLeftStyle: 'solid',
        py: {
          base: '0.625rem',
          md: '0.625rem'
        },
        pl: {
          base: 3,
          md: 3
        }
      }
    }
  }
});